module.exports = __webpack_public_path__ + "img/route-46-mitsu.2dac361a.png";